/**
 * URL builder helper for AI Quiz Supporter iframe
 */

/**
 * Get embed host from environment
 */
export function getEmbedHost(): string {
  let envUrl: string | undefined;

  try {
    // Vite environment
    const metaEnv = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;
    envUrl = metaEnv?.VITE_AI_QUIZ_URL;
  } catch {
    // Non-Vite fallback
  }

  if (!envUrl && typeof process !== 'undefined' && process.env) {
    envUrl = process.env.VITE_AI_QUIZ_URL;
  }

  return envUrl || 'https://aiapi.duynv.online';
}

/**
 * Build full embed URL for iframe src
 */
export function buildEmbedUrl(options?: {
  draftChatId?: string;
}): string {
  const host = getEmbedHost().trim().replace(/\/+$/, '');
  const url = new URL(host.endsWith('/embed') ? host : `${host}/embed`);

  if (options?.draftChatId) {
    url.searchParams.set('draftChatId', options.draftChatId);
  }

  return url.toString();
}
